// extracted by mini-css-extract-plugin
module.exports = {"container":"GImage_container__0l193","image":"GImage_image__rvYoE","fallback":"GImage_fallback__SuWpl","skeleton":"GImage_skeleton__T6Nx5","shimmer":"GImage_shimmer__afgXl"};